import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.RadialMenu}-enter {
		.${Layouts.RadialMenu}-background {
			opacity: 0;
		}

		/* .${Layouts.RadialMenu} {
			opacity: 0;
		} */
	}

	&.${Layouts.RadialMenu}-enter-active,
		&.${Layouts.RadialMenu}-enter-done,
		&.${Layouts.RadialMenu}-exit {
		.${Layouts.RadialMenu}-background {
			opacity: 0.25;
		}

		/* .${Layouts.RadialMenu} {
			opacity: 1;
		} */
	}

	&.${Layouts.RadialMenu}-exit-active {
		.${Layouts.RadialMenu}-background {
			opacity: 0;
		}

		/* .${Layouts.RadialMenu} {
			opacity: 0;
		} */
	}
`;
